import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';
import { getHostFromWindow } from '@qb/frontend/utils/hosts/getHostFromWindow';
import { spsClientQueries } from '@qb/httpRequest/spsClientQueries';
import { SearchPartAutocompleteOmniResponse } from '@/shared/types/controllers/SearchControllerTypes';

const MANUFACTURERS_LIMIT = 3;
export const useManufacturersAutocompleteRequest = (
  query: string,
  tenantAlias: string,
) => {
  const { isLoading: areManufacturersLoading, data: manufacturers = [] } =
    useQuery({
      ...spsClientQueries.search.partAutocomplete(
        getHostFromWindow(),
        tenantAlias,
        query,
      ),
      keepPreviousData: true,
      staleTime: minutesToMilliseconds(1),
      select: getUniqueManufacturers,
      enabled: Boolean(query),
    });

  return {
    areManufacturersLoading,
    manufacturers: manufacturers.slice(0, MANUFACTURERS_LIMIT),
  };
};

const getUniqueManufacturers = (data: SearchPartAutocompleteOmniResponse) => {
  const { parts } = data;
  const manufacturerMap = new Map(
    parts.map((part) => [part.manufacturer.id, part.manufacturer]),
  );
  return Array.from(manufacturerMap.values());
};
